// extracted by mini-css-extract-plugin
export default {"errorMessage":"MagicLinkView-module__errorMessage--f3OYm","animatedBackground":"MagicLinkView-module__animatedBackground--DzGrX"};